import React, { useEffect } from 'react';

import { useOnlineBookingReducer } from 'components/OnlineBooking/state/useOnlineBookingReducer';

import { TroubleShootingStep } from './TroubleShootingStep';

export interface Props {
  descriptionMaxLength?: number;
}

export const TroubleShootingOne = () => {
  const { state, dispatch, actions } = useOnlineBookingReducer();

  const { service } = state;

  useEffect(() => {
    if (!service?.question1) {
      dispatch(actions.skipStep());
    }
  }, [actions, dispatch, service?.question1]);

  return (
    <TroubleShootingStep
      question={service?.question1}
      questionKey="question1"
      dataTestId="question-one"
      onChange={(event) => dispatch(actions.updateQuestionOne(event.target.value))}
    />
  );
};
